class MobileMenu {
  constructor() {
    this.header = document.querySelector('.header')
    this.menu = document.querySelector('.main-nav--header')
    this.button = document.querySelector('.menu-button')
    this.open = false
    this.previous = null
    this.listen()
  }

  listen() {
    // Toggle mobile navigation menu
    this.button.addEventListener('click', (ev) => {
      this.button.classList.toggle('open')
      this.menu.classList.toggle('open')
      this.open = !this.open
      if (this.open) {
        document.body.classList.add('noscroll')
        document.querySelector('.logo').style.color = "white"
        let openItem = this.menu.querySelector('.main-nav__item.open')
        if (openItem) {
          openItem.querySelector('.main-nav__list--sublist').removeAttribute('style')
          openItem.classList.remove('open')
        }
      } else {
        document.body.classList.remove('noscroll')
        document.querySelector('.logo').removeAttribute('style')
      }
    })
    // Toggle dropdown menus
    addEventListener('click', ev => {
      const item = ev.target.closest('[data-dropdown]')
      const clickedLink = ev.target.closest('a')

      if (item && !clickedLink && !(window.innerWidth > 1024 && item.closest('.main-nav--footer'))) {
        if (this.previous === item && item.classList.contains('open')) {
          this.closeMenus()
          this.previous = null
          return
        }
        this.closeMenus()
        item.classList.add('open')
        let menuHeight = item.querySelector('ul').scrollHeight
        item.querySelector('.main-nav__list--sublist').style.maxHeight = menuHeight + "px"
        if (window.innerWidth > 1024) {
          this.header.classList.add('fill')
          this.header.style.paddingBottom = `calc(3rem + ${menuHeight}px)`
        }
        this.previous = item
      } else if (!item) {
        this.closeMenus()
        this.previous = null
      }
    })
  }

  closeMenus() {
    let headerItem = this.menu.querySelector('.main-nav__item.open')
    let footerItem = document.querySelector('.main-nav--footer .main-nav__item.open')
    if (headerItem) {
      headerItem.querySelector('.main-nav__list--sublist').removeAttribute('style')
      headerItem.classList.remove('open')
      this.header.classList.remove('fill')
      this.header.removeAttribute('style')
    }
    if (footerItem) {
      footerItem.querySelector('.main-nav__list--sublist').removeAttribute('style')
      footerItem.classList.remove('open')
    }
  }

}

export default MobileMenu